<!-- 建议提交 -->
<script setup>
import { Message } from '@arco-design/web-vue';
import axios from 'axios'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const visible = ref(false);
const form = reactive({
    contact: '',
    company: '',
    phone: '',
    email: '',
    matter: '',
})

// 验证表单
const validateForm = () => {

    if (!form.contact.trim()) {
        Message.error(t('consult.formError.contactRequired'))
        return false
    }
    
    if (!form.phone.trim() && !form.email.trim()) {
        Message.error(t('consult.formError.phoneOrEmailRequired'))
        return false
    }
    
    if (form.phone.trim() && !/^1[3-9]\d{9}$/.test(form.phone.trim())) {
        Message.error(t('consult.formError.phoneInvalid'))
        return false
    }
    
    if (form.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
        Message.error(t('consult.formError.emailInvalid'))
        return false
    }
    
    if (!form.matter.trim()) {
        Message.error(t('consult.formError.matterRequired'))
        return false
    }
    
    return true
}

const handleClick = () => {
    visible.value = true
}
// 通过 defineExpose 暴露方法
defineExpose({
  handleClick
})
const handleBeforeOk = async (done) => {
    
    // 验证表单
    if (!validateForm()) {
        done(false) // 阻止模态框关闭
        return
    }
    
    try {
        const token = localStorage.getItem('jwt')
        
        
        const res = await axios.post(
            '/console/v1/consult',
            {
                contact: form.contact.trim(),
                company: form.company.trim(),
                phone: form.phone.trim(),
                email: form.email.trim(),
                matter: form.matter.trim()
            },
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        )
        
        // 成功后给用户反馈
        Message.success(res.data.msg)
        
        // 清空表单
        Object.keys(form).forEach(key => {
            form[key] = ''
        })
        
        // 关闭模态框
        done(true)
        
    } catch (error) {
        // 错误处理
        if (error.response) {
            Message.error(error.response.data?.message || t('consult.formError.submitFailed'))
        } else {
            Message.error(t('consult.formError.networkError'))
        }
        done(false) // 阻止模态框关闭
    }
}

const handleCancel = () => {
    visible.value = false
}
</script>

<template>
    <a-modal 
        modal-class="consulting-service-modal"
        v-model:visible="visible" 
        :title="t('consult.modalTitle')" 
        @cancel="handleCancel" 
        @before-ok="handleBeforeOk"
        :mask-closable="false"
    >
        <a-form :model="form" layout="vertical">
            <a-form-item 
                :label="t('consult.formLabels.contact')" 
                name="contact"
                :rules="[{ required: true, message: t('consult.formRules.contactRequired') }]"
                :validate-trigger="['blur', 'input']"
            >
                <a-input 
                    v-model="form.contact" 
                    :placeholder="t('consult.formPlaceholders.contact')" 
                    allow-clear
                />
            </a-form-item>
            
            <a-form-item :label="t('consult.formLabels.company')" name="company">
                <a-input 
                    v-model="form.company" 
                    :placeholder="t('consult.formPlaceholders.company')" 
                    allow-clear
                />
            </a-form-item>
            
            <a-form-item 
                :label="t('consult.formLabels.phone')" 
                name="phone"
                :rules="[
                    { 
                        required: !form.email.trim(), 
                        message: t('consult.formRules.phoneOrEmailRequired')
                    },
                    { 
                        pattern: /^1[3-9]\d{9}$/,
                        message: t('consult.formRules.phonePattern'),
                        validateTrigger: 'blur'
                    }
                ]"
            >
                <a-input 
                    v-model="form.phone" 
                    :placeholder="t('consult.formPlaceholders.phone')" 
                    allow-clear
                />
            </a-form-item>
            
            <a-form-item 
                :label="t('consult.formLabels.email')" 
                name="email"
                :rules="[
                    { 
                        required: !form.phone.trim(), 
                        message: t('consult.formRules.phoneOrEmailRequired')
                    },
                    { 
                        type: 'email',
                        message: t('consult.formRules.emailType'),
                        validateTrigger: 'blur'
                    }
                ]"
            >
                <a-input 
                    v-model="form.email" 
                    :placeholder="t('consult.formPlaceholders.email')" 
                    allow-clear
                />
            </a-form-item>
            
            <a-form-item 
                :label="t('consult.formLabels.matter')" 
                name="matter"
                :rules="[{ required: true, message: t('consult.formRules.matterRequired') }]"
                :validate-trigger="['blur', 'input']"
            >
                <a-textarea 
                    v-model="form.matter" 
                    :placeholder="t('consult.formPlaceholders.matter')" 
                    :max-length="500"
                    show-word-limit
                    :auto-size="{ minRows: 3, maxRows: 6 }"
                />
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<style lang="less" scoped>
</style>